import Banner from "~/components/banner"
import ZoomInBanner from "./banner"
import MarkdownArticle from "~/components/markdownArticle"
import { readFileSync } from "fs"

const article = readFileSync(__dirname + "/article.md", "utf-8")

export default class ZoomIn extends Component {
  render() {
    return (
      <React.Fragment>
        <Banner
          figure={<ZoomInBanner />}
          title="Zoom In"
          subtitle="An introduction to Circuits"
        />
        <MarkdownArticle
          src={article}
          images={{
            micrographia: require("./micrographia.png"),
            schwann: require("./schwann.png"),
            deepdream: require("./deepdream.png"),
            curves: require("./curves.png"),
            polysemantic: require("./polysemantic.png"),
            dogCircuit: require("./dog-circuit.png"),
            curvesAcrossModels: require("./curves-across-models.png"),
            // curveWeights: require("./curve-weights.png"),
            curveOrientations: require("./curve-orientations.png"),
            curveCircuit: require("./curve-circuit.png"),
            orientedDogHead: require("./oriented-dog-heads.png"),
            superposition: require("./superposition.png"),
            freq: require("./freq.png"),
          }}
        />
      </React.Fragment>
    )
  }
}
